<div class="row">
    <div class="col-lg-8">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    (initialized)="grid.initialize(mainGrid)"
                    [itemsSource]="grid.view"
                    (selectionChanged)="getUsersforGroups()"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Action'" [binding]="'action'" [width]="100">
                        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                            <div style="justify-self: center">
                                <button class="btn btn-secondary btn-sm" (click)="send(cell.item)">Send</button>
                            </div>
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="250"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Recipient Groups'" [binding]="'recipients'" [width]="250">
                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                            <span>
                                {{ getRecipientsCellValue(cell) }}
                            </span>
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Scheduled Date'"
                        [binding]="'scheduledDate'"
                        [format]="'g'"
                        [width]="175"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Expires On'"
                        [binding]="'expiresOn'"
                        [format]="'MM/dd/yyyy'"
                        [width]="130"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Popup Body'" [binding]="'body'" [width]="'1.25*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>

    <div class="col-lg-4" [hidden]="!grid.selectedItem">
        <div class="row">
            <div class="col-12">
                <h4 style="margin-bottom: 11px">Main Body Text</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <quill-view [content]="grid.selectedItem?.richBody"></quill-view>
            </div>
        </div>

        <div class="row action-toolbar" style="margin-top: 15px">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="usersGrid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="usersGrid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridUsers"
                    #gridUsers
                    appAutoSize
                    (initialized)="usersGrid.initialize(gridUsers)"
                    [itemsSource]="usersGrid.view"
                    (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Users To Be Notified'"
                        [binding]="'displayName'"
                        [width]="'*'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Accepted Notifications'" [binding]="'hasToken'" [width]="130"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
